import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import Input from '../Input';
const Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
const InputElement = styled(Input)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
const Components = {
  Wrapper,
  InputElement
};
export { Components };